import { BarChart } from "./BarChart";
import { AnimatedCounter } from "./AnimatedCounter";

const comparisonMetrics = [
  {
    label: "Inbox Placement Rate",
    q1: 89.8,
    q4: 82.4,
    unit: "%"
  },
  {
    label: "Email Open Rate",
    q1: 38.2,
    q4: 31.5,
    unit: "%"
  },
  {
    label: "Click-Through Rate",
    q1: 4.8,
    q4: 3.1,
    unit: "%"
  },
  {
    label: "Conversion Rate",
    q1: 6.1,
    q4: 3.1,
    unit: "%"
  },
  {
    label: "Spam Placement",
    q1: 4.2,
    q4: 8.6,
    unit: "%",
    inverted: true
  }
];

export const QuarterComparisonChart = () => {
  return (
    <section className="section-card mt-5 sm:mt-7">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-baseline gap-1.5 sm:gap-2 mb-5 sm:mb-6">
        <h2 className="font-display text-lg sm:text-xl font-semibold tracking-tight text-foreground">
          Q1 vs Q4 performance comparison
        </h2>
        <p className="text-[11px] sm:text-xs text-muted-foreground">
          How key email metrics shift from Q1 to Q4
        </p>
      </div>

      {/* Legend */}
      <div className="flex items-center gap-4 mb-5">
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-sm bg-primary" />
          <span className="text-xs text-muted-foreground">Q1 (Jan-Mar)</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-sm bg-destructive" />
          <span className="text-xs text-muted-foreground">Q4 (Oct-Dec)</span>
        </div>
      </div>

      <div className="space-y-5">
        {comparisonMetrics.map((metric, i) => {
          const maxVal = Math.max(metric.q1, metric.q4);
          const q1Normalized = (metric.q1 / maxVal) * 100;
          const q4Normalized = (metric.q4 / maxVal) * 100;
          const change = ((metric.q4 - metric.q1) / metric.q1 * 100).toFixed(0);
          const isNegativeChange = metric.inverted ? Number(change) > 0 : Number(change) < 0;
          
          return (
            <div key={i} className="space-y-2">
              <div className="flex items-baseline justify-between">
                <span className="text-xs sm:text-sm font-medium text-foreground">{metric.label}</span>
                <span className={`text-xs font-medium ${isNegativeChange ? 'text-destructive' : 'text-emerald-600'}`}>
                  {Number(change) > 0 ? '+' : ''}{change}%
                </span>
              </div>
              
              <div className="grid grid-cols-2 gap-3">
                <div className="space-y-1">
                  <div className="flex items-center justify-between">
                    <span className="text-[10px] text-muted-foreground">Q1</span>
                    <span className="text-xs font-semibold text-foreground">
                      <AnimatedCounter value={metric.q1} suffix={metric.unit} duration={1200 + i * 100} />
                    </span>
                  </div>
                  <BarChart percentage={q1Normalized} />
                </div>
                
                <div className="space-y-1">
                  <div className="flex items-center justify-between">
                    <span className="text-[10px] text-muted-foreground">Q4</span>
                    <span className="text-xs font-semibold text-foreground">
                      <AnimatedCounter value={metric.q4} suffix={metric.unit} duration={1200 + i * 100} />
                    </span>
                  </div>
                  <BarChart percentage={q4Normalized} variant="red" />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="border-t border-border mt-5 pt-4">
        <p className="text-[10px] sm:text-[11px] text-muted-foreground leading-relaxed">
          Data aggregated from Validity, GetResponse, Stripo, and TargetBay reports. Q4 metrics reflect holiday period pressures including increased competition and stricter filtering.
        </p>
      </div>
    </section>
  );
};
